import { reactive, watch } from 'vue'

import { useFiltersStore } from '~/stores/useFiltersStore'

interface MoreFiltersDraft {
  individualPackaging: boolean
  isNew: boolean
  smallBusiness: boolean
  distance: string
}

/** The More Filters draft: seeded from the filters store whenever the modal opens, written back on apply or clear. */
export function useMoreFiltersDraft(isOpen: () => boolean, close: () => void) {
  const filtersStore = useFiltersStore()
  const filters = reactive<MoreFiltersDraft>({
    distance: '',
    individualPackaging: false,
    isNew: false,
    smallBusiness: false
  })

  const initialize = () => {
    filters.individualPackaging = filtersStore.selectedOtherFilters.includes('individualPackaging')
    filters.isNew = filtersStore.selectedOtherFilters.includes('new')
    filters.smallBusiness = filtersStore.selectedOtherFilters.includes('smallBusiness')
    filters.distance =
      filtersStore.selectedDistance === null ? '' : String(filtersStore.selectedDistance)
  }

  watch(
    isOpen,
    (open) => {
      if (open) initialize()
    },
    { immediate: true }
  )

  const clear = () => {
    filters.individualPackaging = false
    filters.isNew = false
    filters.smallBusiness = false
    filters.distance = ''

    filtersStore.selectedOtherFilters = []
    filtersStore.selectedDistance = null

    close()
  }

  const apply = () => {
    const otherFilters: ('individualPackaging' | 'new' | 'smallBusiness')[] = []
    if (filters.individualPackaging) otherFilters.push('individualPackaging')
    if (filters.isNew) otherFilters.push('new')
    if (filters.smallBusiness) otherFilters.push('smallBusiness')

    filtersStore.selectedOtherFilters = otherFilters
    filtersStore.selectedDistance = filters.distance.trim() === '' ? null : filters.distance

    close()
  }

  return { apply, clear, filters }
}
